<script setup lang="ts">
const socialLinks = ref([
  {
    title: "Sales Office",
    socialLinkImg: "/images/gmailImg.webp",
    socialLinkDarkImg: "/images/gmailDarkImg.webp",
    socialLinkLightImg: "/images/gmailLightImg.webp",
    information: "we@webreinvent.com",
    organisationEmail: "we@webreinvent.com",
    altText: "Gmail Image",
    height: 135,
    width: 135,
    email: "WrWebreinvent",
  },
  {
    title: "Schedule Meeting",
    socialLinkImg: "/images/calendly-logo.webp",
    socialLinkDarkImg: "/images/meetDarkImg.webp",
    socialLinkLightImg: "/images/meetLightImg.webp",
    information: "WebReinvent",
    altText: "Meet Image",
    height: 135,
    width: 179,
    link: "https://calendly.com/webreinvent/consult",
    email: "WrWebreinvent",
  },
  {
    title: "Jobs",
    socialLinkImg: "/images/briefcase.webp",
    socialLinkDarkImg: "/images/briefcasebg.png",
    socialLinkLightImg: "/images/briefcasebg-light.png",
    altText: "jobs image",
    height: 125,
    width: 125,
    link: "https://webreinvent.ohoapps.com/hrm/v4#/jobs",
    email: "WrResumeWri",
  },
]);

const visible = ref(false);
const handleOpen = () => {
  visible.value = true;
};
</script>
<template>
  <template v-for="socialLink in socialLinks">
    <div
      class="p-px rounded-xl bg-[image:var(--border-social-card)] !bg-no-repeat w-full max-w-[298px]"
    >
      <NuxtLink
        v-if="socialLink.title !== 'Sales Office'"
        :to="socialLink.link"
        target="_blank"
        class="cursor-pointer"
        @click="socialLink.link == '' ? handleOpen() : null"
      >
        <div
          class="relative pt-[75px] pb-8 pl-7 rounded-xl w-full border-[#9D00FF] overflow-hidden"
          :style="{
            backgroundImage: `url(${
              $colorMode.preference == 'dark'
                ? socialLink.socialLinkDarkImg
                : socialLink.socialLinkLightImg
            })`,
          }"
        >
          <div class="flex flex-col items-start justify-start">
            <div class="max-w-[66px] max-h-[66px] h-full w-full">
              <NuxtImg
                loading="lazy"
                :alt="socialLink.altText"
                :src="socialLink.socialLinkImg"
                format="webp"
                width="66px"
                :height="socialLink.title == 'Jobs' ? undefined : '66px'"
                :fit="socialLink.title == 'Jobs' ? undefined : 'cover'"
                :class="
                  socialLink.title == 'Jobs'
                    ? 'h-[66px] w-[66px] object-contain'
                    : 'object-cover'
                "
              />
            </div>
            <p class="text-white text-lg font-semibold">
              {{ socialLink.title }}
            </p>
            <p class="text-white text-base tracking-[0.5px]">
              <WrSVGIcon
                v-if="socialLink.title !== 'Sales Office'"
                :name="socialLink.email"
                :class="
                  socialLink.title == 'Jobs'
                    ? 'h-[30px] w-[250px]'
                    : 'h-[30px] w-[208px]'
                "
              />
            </p>
          </div>
        </div>
      </NuxtLink>
      <div v-else class="cursor-pointer" @click="handleOpen()">
        <div
          class="relative pt-[75px] pb-8 pl-7 rounded-xl w-full border-[#9D00FF] overflow-hidden"
          :style="{
            backgroundImage: `url(${
              $colorMode.preference == 'dark'
                ? socialLink.socialLinkDarkImg
                : socialLink.socialLinkLightImg
            })`,
          }"
        >
          <div class="flex flex-col items-start justify-start">
            <div class="max-w-[66px] max-h-[66px] h-full w-full">
              <NuxtImg
                loading="lazy"
                :alt="socialLink.altText"
                :src="socialLink.socialLinkImg"
                format="webp"
                height="66px"
                width="66px"
              />
            </div>
            <p class="text-white text-lg font-semibold">
              {{ socialLink.title }}
            </p>
            <p class="text-white text-base tracking-[0.5px]">
              <WrSVGIcon
                v-if="socialLink.title == 'Sales Office'"
                :name="socialLink.email"
                class="h-[30px] w-[208px]"
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  </template>
  <WrContactFormPopup :isOpen="visible" @close="visible = false" class="z-30" />
</template>
